import { createSelector } from '@reduxjs/toolkit';

export const cartStateSelector = (rootReducer: any) => rootReducer.cart;

export const productsInCartSelector = createSelector(cartStateSelector, stateProp => stateProp.productsInCart);
export const summaryInCartSelector = createSelector(cartStateSelector, stateProp => stateProp.summaryInCart);
export const retryPaymentSelector = createSelector(cartStateSelector, stateProp => stateProp.retryPayment);
export const cartActiveSelector = createSelector(cartStateSelector, stateProp => stateProp.cartActive);
export const productsInLastCartSelector = createSelector(cartStateSelector, stateProp => stateProp.lastCartState.productsInCart);
export const summaryInLastCartSelector = createSelector(cartStateSelector, stateProp => stateProp.lastCartState.summaryInCart);